var map = {
	"./IMG_104_VIDEO.mp4": 67273,
	"./IMG_109_VIDEO.mp4": 19296,
	"./IMG_20_1824_VIDEO.mp4": 7852,
	"./IMG_28_1824_VIDEO.mp4": 95188,
	"./IMG_32_1824_VIDEO.mp4": 35591,
	"./IMG_39_VIDEO.mp4": 79878,
	"./IMG_41_VIDEO.mp4": 97095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68262;